import { FoundationElement } from "../foundation-element/foundation-element.js";
/**
 * A TabPanel Component to be used with {@link @microsoft/fast-foundation#(Tabs:class)}
 * @public
 */
export class TabPanel extends FoundationElement {
}
